import { Model } from './model';

export class ShipType extends Model {
  value: string;
  display_name: string;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new ShipType(values);
  }
}

export class ShipTypeAssociation extends Model {
  shiptype: string;
  shiptype_label: string;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new ShipType(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/ship-type.ts